var map = {
	"./Classe.vue": "6997",
	"./CommunicationHeader.vue": "1b3e",
	"./Count.vue": "0165",
	"./Familiare.vue": "8ad5",
	"./Footer.vue": "fd2d",
	"./GenitoreClasse.vue": "959a",
	"./Header.vue": "0418",
	"./Loading.vue": "3a5e",
	"./ModalConfirm.vue": "b275",
	"./Sidebar.vue": "5ea5",
	"./minore.vue": "ed80"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "914c";